import React from "react";
import "./MeetCoach.css";
// Import Material-UI components for layout and styling
import { Box, Grid, Typography, Button } from "@mui/material";
// Import website configuration for images
import { websiteImages } from "../../../config/config";

// Define the MeetCoach component
const MeetCoach = () => {
  return (
    <>
      <div>
        {/* Main container with background image */}
        <Box
          sx={{
            backgroundImage: `url(${websiteImages.subcriptionBg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <div className="container-fluied">
            <Grid
              container
              spacing={0}
              className="container-fluied"
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                alignItems: "center",
              }}
            >
              {/* Left section: Image */}
              <Grid
                item
                size={{ xs: 12, md: 6 }}
                sx={{
                  display: "flex",
                  padding: 0,
                }}
              >
                <div className="leftImage-box">
                  <img src={websiteImages.dumbbellMen} alt="Dumbbell Men" />
                </div>
              </Grid>

              {/* Right section: Content */}
              <Grid
                item
                size={{ xs: 12, md: 6 }}
                sx={{
                  display: "flex",
                  alignItems: { xs: "start", sm: "start", md: "center" },
                  paddingTop: 5,
                  paddingBottom: 5,
                }}
              >
                <Box className="rightContent-box">
                  {/* Small title */}
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontSize: {
                        xs: "10px",
                        sm: "10px",
                        md: "10px",
                        lg: "11px",
                        xl: "12px",
                      },
                      fontWeight: 700,
                      letterSpacing: {
                        xs: "1px",
                        sm: "2px",
                        md: "4px",
                        lg: "8px",
                        xl: "10px",
                      },
                      marginTop: {
                        xs: "10px",
                        sm: "10px",
                        md: "8px",
                        lg: "10px",
                      },
                      color: "rgba(255, 255, 255, 0.8)",
                      textTransform: "uppercase",
                    }}
                  >
                    MEET COACH Paul Gradwell
                  </Typography>

                  {/* Main heading */}
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: {
                        // xs: "15px",
                        sm: "21px",
                        md: "27px",
                        lg: "33px",
                        xl: "40px",
                      },
                      fontWeight: 700,
                      lineHeight: { xs: "1.1", md: "1.2", lg: "1.3" },
                      marginTop: { xs: "10px", sm: "10px", md: "10px" },
                      color: "white",
                      textTransform: "uppercase",
                      maxWidth: {
                        xs: "100%",
                        sm: "90%",
                        xl: "520px",
                      },
                      textAlign: "start",
                    }}
                  >
                    Built by a Coach Who’s Done It All — And Still Does
                  </Typography>

                  {/* Description */}
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: {
                        xs: "10px",
                        sm: "12px",
                        md: "12px",
                        lg: "12px",
                        xl: "16px",
                      },
                      lineHeight: 1.4,
                      marginTop: {
                        xs: "10px",
                        sm: "12px",
                        md: "12px",
                        lg: "15px",
                      },
                      color: "rgba(255, 255, 255, 0.9)",
                      maxWidth: {
                        xs: "100%",
                        sm: "80%",
                        md: "385px",
                        lg: "480px",
                        xl: "540px",
                      },
                      textAlign: "start",
                    }}
                  >
                    I’m Paul Gradwell — Body Recomposition Specialist and Hybrid
                    Conditioning Coach. Since 2009, I’ve helped over 1,000
                    clients transform their bodies through a structured,
                    sustainable system. Olympic athletes. Burned-out parents.
                    Everyday high performers. I’ve coached them all — and now I
                    coach you.
                  </Typography>

                  {/* List of achievements */}
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: {
                        xs: "10px",
                        sm: "12px",
                        md: "12px",
                        lg: "12px",
                        xl: "16px",
                      },
                      lineHeight: 1.4,
                      marginTop: {
                        xs: "10px",
                        sm: "16px",
                        md: "18px",
                        lg: "20px",
                      },
                      color: "rgba(255, 255, 255, 0.9)",
                      maxWidth: {
                        xs: "100%",
                        sm: "80%",
                        md: "385px",
                        lg: "480px",
                        xl: "560px",
                      },
                      textAlign: "start",

                      "& ul": {
                        paddingLeft: "1.2rem",
                        margin: 0,
                        listStyleType: "none",
                        position: "relative",
                      },
                      "& li": {
                        color: "#fff",
                        paddingBottom: { xs: "6px", sm: "8px", md: "10px" },
                        fontWeight: { xs: 500, md: 500 },
                        position: "relative",
                        paddingLeft: { xs: "20px", sm: "24px", md: "28px" },
                        "&:before": {
                          content: '""',
                          position: "absolute",
                          left: 0,
                          top: { xs: "6px", sm: "8px", md: "10px" },
                          width: { xs: "4px", sm: "5px", md: "6px" },
                          height: { xs: "4px", sm: "5px", md: "6px" },
                          backgroundColor: "#00ffff",
                          borderRadius: "50%",
                        },
                      },
                    }}
                  >
                    <ul>
                      <li> 16 Years Experience</li>
                      <li> 1,000+ Clients Recomped</li>
                      <li> Olympic & General Pop Coaching </li>
                      <li> Hormonal Health & Fat Loss Expert</li>
                      <li> Creator of the Recomp Plus System</li>
                    </ul>
                  </Typography>

                  {/* Call-to-action button */}
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#00ffff",
                      color: "#111111",
                      fontSize: {
                        xs: "12px",
                        sm: "12px",
                        md: "12px",
                        lg: "12px",
                        xl: "12px",
                      },
                      marginTop: {
                        xs: "12px",
                        sm: "25px",
                        md: "26px",
                        lg: "20px",
                      },
                      fontWeight: 700,
                      padding: {
                        xs: "10px 20px",
                        sm: "12px 24px",
                        md: "13px 26px",
                        lg: "14px 28px",
                        xl: "15px 30px",
                      },
                      borderRadius: "25px",
                      textTransform: "uppercase",
                      letterSpacing: "1px",
                      transition: "all 0.3s ease",
                      minWidth: "auto",
                      whiteSpace: "nowrap",
                      "&:hover": {
                        backgroundColor: "#00ffff",
                        transform: "translateY(-2px)",
                        boxShadow: "0 4px 12px rgba(0, 198, 194, 0.3)",
                      },
                    }}
                    onClick={() => {
                      const section = document.getElementById(
                        "subscription-section"
                      );
                      if (section) {
                        section.scrollIntoView({ behavior: "smooth" });
                      }
                    }}
                  >
                    Meet Your Coach
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </div>
        </Box>
      </div>
    </>
  );
};

// Export the MeetCoach component
export default MeetCoach;
